import { apiService, getApiBaseUrl } from './api';
import {
  AvailableSection,
  GenerateReportPayload,
  ReportTemplate,
  ReportTemplateCreate,
  ReportTemplateUpdate,
} from '../types';

export class ReportTemplatesService {
  async duplicate(id: string): Promise<ReportTemplate> {
    return apiService.post<ReportTemplate>(`/reports/templates/${id}/duplicate`, {});
  }

  async list(): Promise<ReportTemplate[]> {
    return apiService.get<ReportTemplate[]>('/reports/templates');
  }

  async getById(id: string): Promise<ReportTemplate> {
    return apiService.get<ReportTemplate>(`/reports/templates/${id}`);
  }

  async create(payload: ReportTemplateCreate): Promise<ReportTemplate> {
    return apiService.post<ReportTemplate>('/reports/templates', payload);
  }

  async update(id: string, payload: ReportTemplateUpdate): Promise<ReportTemplate> {
    return apiService.put<ReportTemplate>(`/reports/templates/${id}`, payload);
  }

  async delete(id: string): Promise<void> {
    return apiService.delete<void>(`/reports/templates/${id}`);
  }

  async listAvailableSections(): Promise<AvailableSection[]> {
    return apiService.get<AvailableSection[]>('/reports/section-types');
  }

  async generate(payload: GenerateReportPayload): Promise<void> {
    const response = await fetch(`${getApiBaseUrl()}/reports/generate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(await apiService.authHeaders()),
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Failed to generate report: ${response.status} ${text}`);
    }
    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition') || '';
    const match = disposition.match(/filename="?([^";]+)"?/i);
    const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    const filename = encoded ? decodeURIComponent(encoded[1]) : match ? match[1] : 'report.docx';
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
}

export const reportTemplatesService = new ReportTemplatesService();
